module.exports = __webpack_public_path__ + "img/图像-38@2x.3f61127e.webp";